import { useQuery } from "react-query";

import * as reviewService from "api/services/reviewsService";
import * as incrementalityMonitoringService from "api/services/incrementalityMonitoringService";

/**
 * Store server's state of financials results
 *
 * @returns The query object returned by the useQuery hook
 */
export const useIncrementalityMonitoringReviewsHooks = () =>
  useQuery(
    ["incrementalityMonitoringReviews"],
    () => reviewService.getIncrementalityMonitoringReviews(),
    {
      select: ({ data }) => data,
    }
  );

/**
 * Store server's state of incrementality monitoring modal result
 *
 * @param {number} municipalityId
 * @returns The query object returned by the useQuery hook
 */
export const useIncrementalityMonitoringModal = (municipalityId) =>
  useQuery(
    ["incrementality", municipalityId],
    () => incrementalityMonitoringService.getByMunicipality(municipalityId),
    {
      select: ({ data }) => data,
      enabled: !!municipalityId,
    }
  );
